var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_754)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 16C26.7452 16 16 26.7452 16 40C16 42.2091 14.2091 44 12 44C9.79087 44 8 42.2091 8 40C8 22.3269 22.3269 8 40 8C57.6731 8 72 22.3269 72 40C72 57.6731 57.6731 72 40 72C37.7909 72 36 70.2091 36 68C36 65.7909 37.7909 64 40 64C53.2548 64 64 53.2548 64 40C64 26.7452 53.2548 16 40 16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64732 25.7651C3.43393 24.4657 5.9356 24.8607 7.23495 26.6473L13.1687 34.8062L21.0846 30.4884C23.024 29.4306 25.4537 30.1452 26.5116 32.0846C27.5694 34.024 26.8548 36.4537 24.9154 37.5116L13.9154 43.5116C12.1512 44.4739 9.94701 43.9779 8.76506 42.3527L0.765063 31.3527C-0.53429 29.5661 -0.13929 27.0644 1.64732 25.7651Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 22C42.2091 22 44 23.7909 44 26L44 36L54 36C56.2091 36 58 37.7909 58 40C58 42.2091 56.2091 44 54 44L40 44C37.7909 44 36 42.2091 36 40L36 26C36 23.7909 37.7909 22 40 22Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastTime);
export default __webpack_public_path__ + "static/media/last-time.32f14c4aa2d093d9e3f37d86e3fa9099.svg";
export { ForwardRef as ReactComponent };